export const WHATSAPP_URL = "https://wa.me/60142113390";
export const TELEGRAM_URL = "https://t.me/Mbglobal96";
export const OFFICIAL_URL = "https://mbpayvia.com";
export const WHATSAPP_DISPLAY = "+60 14-211 3390";
export const TELEGRAM_DISPLAY = "@Mbglobal96";
export const DEADLINE = "31 DEC 2026";

export const waLink = (text) =>
  text ? `${WHATSAPP_URL}?text=${encodeURIComponent(text)}` : WHATSAPP_URL;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
